(function () {
'use strict';
if (window.ComboCart || !window.CCLib) return;
var L = window.CCLib;
var CFG = L.CFG, ROOT = L.ROOT, T = L.T, on = L.on;
var esc = L.esc, money = L.money, sized = L.sized, api = L.api;
var ICON_CART = L.ICON_CART, ICON_X = L.ICON_X, ICON_TAG = L.ICON_TAG, ICON_LOCK = L.ICON_LOCK;
var cache = {};
var state = { cart: null, focus: null, data: null };
var els = {};
try { state.focus = sessionStorage.getItem('cc-focus'); } catch (e) {}
function getData(handle) {
if (handle in cache) return Promise.resolve(cache[handle]);
return fetch(ROOT + 'products/' + encodeURIComponent(handle) + '?section_id=combo-cart-data')
.then(function (r) { return r.ok ? r.text() : ''; })
.then(function (html) {
var m = html.match(/<script[^>]*data-combo-json[^>]*>([\s\S]*?)<\/script>/);
var d = null;
try { d = m ? JSON.parse(m[1]) : null; } catch (e) { d = null; }
cache[handle] = d;
return d;
})
.catch(function () { return null; });
}
function pickFocus(cart) {
var handles = [];
cart.items.forEach(function (i) { if (handles.indexOf(i.handle) < 0) handles.push(i.handle); });
if (state.focus && handles.indexOf(state.focus) > -1) {
handles.splice(handles.indexOf(state.focus), 1);
handles.unshift(state.focus);
}
handles = handles.slice(0, 5);
var idx = 0;
function next() {
if (idx >= handles.length) return Promise.resolve(null);
return getData(handles[idx++]).then(function (d) {
return d && d.activar && d.variants && d.variants.length ? d : next();
});
}
return next();
}
function build() {
if (els.root) return;
var root = document.createElement('div');
root.className = 'cc-root';
root.innerHTML =
'<div class="cc-overlay" data-cc-close></div>' +
'<aside class="cc-drawer" role="dialog" aria-modal="true" aria-label="' + esc(T('cartLabel', 'Carrito')) + '" tabindex="-1">' +
'<header class="cc-head"><div class="cc-head__title">' + ICON_CART + '<span>' + esc(T('title', 'Tu carrito')) + '</span></div>' +
'<button type="button" class="cc-x" data-cc-close aria-label="' + esc(T('closeLabel', 'Cerrar')) + '">' + ICON_X + '</button></header>' +
'<div class="cc-top"></div>' +
'<div class="cc-body"></div>' +
'<footer class="cc-foot"></footer>' +
'<div class="cc-loading" aria-hidden="true"><span class="cc-spin"></span></div>' +
'</aside>';
document.body.appendChild(root);
els.root = root;
els.drawer = root.querySelector('.cc-drawer');
els.body = root.querySelector('.cc-body');
els.foot = root.querySelector('.cc-foot');
L.applyTheme(root);
root.querySelector('.cc-top').innerHTML = L.topHTML();
L.startTimer(root);
root.addEventListener('click', onClick);
root.addEventListener('change', onChange);
root.addEventListener('keydown', function (e) {
if (e.key === 'Escape') close();
if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-cc-tier]')) {
e.preventDefault();
selectTier(Number(e.target.getAttribute('data-cc-tier')));
}
});
var tpl = document.getElementById('cc-payment-icons');
els.payments = tpl ? tpl.innerHTML : '';
}
function busy(on) { if (els.drawer) els.drawer.classList.toggle('is-busy', !!on); }
function open() {
build();
if (!state.cart) els.body.innerHTML = '';
els.root.classList.add('is-open');
document.documentElement.classList.add('cc-lock');
setTimeout(function () { try { els.drawer.focus({ preventScroll: true }); } catch (e) {} }, 50);
}
function close() {
if (!els.root) return;
els.root.classList.remove('is-open');
document.documentElement.classList.remove('cc-lock');
}
function unitsOf(data, cart) {
var units = [];
cart.items.forEach(function (i) {
if (i.product_id === data.id) for (var q = 0; q < i.quantity; q++) units.push(i.variant_id);
});
return units;
}
function variantById(data, id) {
for (var i = 0; i < data.variants.length; i++) if (data.variants[i].id === id) return data.variants[i];
return null;
}
function firstAvailable(data) {
for (var i = 0; i < data.variants.length; i++) if (data.variants[i].available) return data.variants[i].id;
return data.variants[0].id;
}
function fill(units, n, data) {
var out = units.slice(0, n);
var filler = out.length ? out[out.length - 1] : firstAvailable(data);
while (out.length < n) out.push(filler);
return out;
}
function vsOf(data, ids) { return ids.map(function (id) { return variantById(data, id) || data.variants[0]; }); }
function tierInfo(data, n, vs) {
var c = L.tierCalc(data, n, vs);
var defTitles = { 1: T('t1', 'Compra 1 unidad'), 2: T('t2', 'Compra 2 y ahorra {descuento}'), 3: T('t3', 'Compra 3 y ahorra {descuento}') };
var defBadges = { 1: T('b1', ''), 2: T('b2', 'Más vendido'), 3: T('b3', 'Ahorro máximo') };
var title = (data['t' + n] || defTitles[n]).replace(/\{descuento\}/gi, c.label);
var badge = data['b' + n];
if (badge == null || badge === '') badge = defBadges[n];
if (badge === '-') badge = '';
return { n: n, c: c, title: title, badge: badge };
}
function lineHTML(item) {
var img = item.image ? sized(item.image, 160) : '';
var disc = item.original_line_price > item.final_line_price;
var variant = item.product_has_only_default_variant ? '' : item.variant_title;
return '<div class="cc-line">' +
'<div class="cc-line__img">' + (img ? '<img src="' + esc(img) + '" alt="" width="60" height="60" loading="lazy">' : '') +
'<span class="cc-qty">' + item.quantity + '</span></div>' +
'<div class="cc-line__info"><div class="cc-line__title">' + esc(item.product_title) + '</div>' +
(variant ? '<div class="cc-line__var">' + esc(variant) + '</div>' : '') +
'<div class="cc-line__price">' + (disc ? '<s>' + money(item.original_line_price) + '</s>' : '') +
'<b>' + money(item.final_line_price) + '</b></div></div>' +
'<button type="button" class="cc-line__rm" data-cc-remove="' + esc(item.key) + '" aria-label="' + esc(T('removeLabel', 'Eliminar')) + '">' + ICON_X + '</button>' +
'</div>';
}
function offersHTML(data, cart) {
var units = unitsOf(data, cart);
var qty = units.length;
var multi = data.variants.length > 1;
var html = '<div class="cc-offers"><div class="cc-offers__head">' + esc(T('offersTitle', '¡Aprovecha nuestros combos!')) + '</div>' +
'<div class="cc-offers__prod">' + esc(data.title) + '</div>';
[1, 2, 3].forEach(function (n) {
var sel = qty === n;
var tu = sel ? units : fill(units, n, data);
var vs = vsOf(data, tu);
var t = tierInfo(data, n, vs);
if (!t.c.active) return;
var compare = 0, price = t.c.price;
vs.forEach(function (v) { compare += v.compare > v.price ? v.compare : v.price; });
var strike = n === 1 ? compare : t.c.base;
var v0 = variantById(data, tu[0]);
var img = (v0 && v0.image) || data.image;
html += '<div class="cc-offer' + (sel ? ' is-sel' : '') + '" data-cc-tier="' + n + '" role="radio" aria-checked="' + sel + '" tabindex="0">' +
'<div class="cc-offer__row">' +
(img ? '<img class="cc-offer__img" src="' + esc(sized(img, 160)) + '" alt="" width="54" height="54" loading="lazy">' : '') +
'<div class="cc-offer__info"><div class="cc-offer__title">' + esc(t.title) + '</div>' +
'<div class="cc-offer__prices">' + (strike > price ? '<s>' + money(strike) + '</s>' : '') +
'<b>' + money(price) + '</b>' +
(t.badge ? '<span class="cc-badge cc-badge--' + n + '">' + esc(t.badge) + '</span>' : '') +
'</div></div><span class="cc-radio" aria-hidden="true"></span></div>';
if (sel && multi) {
html += '<div class="cc-sels">';
units.forEach(function (id, i) {
html += '<label class="cc-sel"><span>' + (i + 1) + '.</span><select data-cc-unit="' + i + '" aria-label="' + esc(T('unitLabel', 'Variante unidad')) + ' ' + (i + 1) + '">';
data.variants.forEach(function (v) {
html += '<option value="' + v.id + '"' + (v.id === id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' +
esc(v.title) + (v.available ? '' : ' (' + esc(T('soldOutText', 'agotado')) + ')') + '</option>';
});
html += '</select></label>';
});
html += '</div>';
}
html += '</div>';
});
return html + '</div>';
}
function nudgeHTML(data, cart) {
if (!on('showNudge', true)) return '';
var units = unitsOf(data, cart), n = units.length + 1;
if (n > 3) return '';
var t = tierInfo(data, n, vsOf(data, fill(units, n, data)));
if (!t.c.active) return '';
return L.nudgeHTML(n, t.c.label, money(t.c.save));
}
function summaryHTML(cart) {
var disc = cart.total_discount || 0;
return '<div class="cc-sum">' +
'<div class="cc-sum__row"><span>' + esc(T('subtotalText', 'Subtotal')) + '</span><span>' + money(cart.original_total_price) + '</span></div>' +
(disc > 0 ? '<div class="cc-sum__row cc-sum__disc"><span>' + ICON_TAG + esc(T('discountText', 'Descuentos')) + '</span><span>- ' + money(disc) + '</span></div>' : '') +
'<div class="cc-sum__total"><span>' + esc(T('totalText', 'Total')) + '</span><span>' + money(cart.total_price) + '</span></div>' +
(disc > 0 && on('showSavings', true) ? '<div class="cc-sum__save">' + esc(T('savingsText', '¡Estás ahorrando {monto}!')).replace(/\{monto\}/gi, money(disc)) + '</div>' : '') +
'</div>';
}
function render() {
build();
var cart = state.cart;
if (!cart || !cart.items.some(L.notProt)) {
els.body.innerHTML = '<div class="cc-empty">' + ICON_CART + '<p>' + esc(T('emptyText', 'Tu carrito está vacío')) + '</p>' +
'<button type="button" class="cc-btn-outline" data-cc-close>' + esc(T('continueText', 'Seguir comprando')) + '</button></div>';
els.foot.innerHTML = '';
els.foot.hidden = true;
return;
}
var html = L.itemsTitleHTML() + '<div class="cc-lines">' + cart.items.filter(L.notProt).map(lineHTML).join('') + '</div>';
if (state.data && on('showOffers', true)) html += nudgeHTML(state.data, cart) + offersHTML(state.data, cart);
html += L.protHTML(cart) + summaryHTML(cart);
els.body.innerHTML = html;
els.foot.hidden = false;
els.foot.innerHTML =
'<button type="button" class="cc-checkout" data-cc-checkout>' + esc(T('checkoutText', 'Finalizar compra')) + (on('showTotalInButton', true) ? ' - ' + money(cart.total_price) : '') + '</button>' +
(on('showSecure', true) ? '<div class="cc-secure">' + ICON_LOCK + '<span>' + esc(T('secureText', 'Pago 100% seguro')) + '</span></div>' : '') +
(els.payments && on('showPayments', true) ? '<div class="cc-pay">' + els.payments + '</div>' : '') + L.trustHTML();
}
function updateBubble() {
return fetch(ROOT + '?sections=cart-icon-bubble')
.then(function (r) { return r.json(); })
.then(function (s) {
var el = document.getElementById('cart-icon-bubble');
if (!el || !s['cart-icon-bubble']) return;
var doc = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
var sec = doc.querySelector('.shopify-section');
el.innerHTML = sec ? sec.innerHTML : doc.body.innerHTML;
})
.catch(function () {});
}
function refresh() {
busy(true);
return api('cart.js')
.then(L.protEnsure)
.then(function (cart) {
state.cart = cart;
return cart.item_count ? pickFocus(cart) : null;
})
.then(function (data) {
state.data = data;
render();
updateBubble();
})
.catch(function (e) { console.error('[ComboCart]', e); })
.then(function () { busy(false); });
}
function applyUnits(data, units) {
var updates = {};
data.variants.forEach(function (v) { updates[v.id] = 0; });
units.forEach(function (id) { updates[id] = (updates[id] || 0) + 1; });
busy(true);
return api('cart/update.js', { updates: updates })
.catch(function (e) { console.error('[ComboCart]', e); })
.then(refresh);
}
function selectTier(n) {
var data = state.data, cart = state.cart;
if (!data || !cart) return;
var units = unitsOf(data, cart);
if (units.length === n) return;
state.focus = data.handle;
applyUnits(data, fill(units, n, data));
}
function onClick(e) {
var t = e.target;
if (t.closest('[data-cc-close]')) { e.preventDefault(); close(); return; }
var rm = t.closest('[data-cc-remove]');
if (rm) {
busy(true);
api('cart/change.js', { id: rm.getAttribute('data-cc-remove'), quantity: 0 })
.catch(function (err) { console.error('[ComboCart]', err); })
.then(refresh);
return;
}
if (t.closest('[data-cc-checkout]')) {
busy(true);
window.location.href = '/checkout';
return;
}
if (t.closest('[data-cc-prot]')) { busy(true); L.protToggle(state.cart).catch(function () {}).then(refresh); return; }
if (t.closest('select, .cc-sels')) return;
var tier = t.closest('[data-cc-tier]');
if (tier) selectTier(Number(tier.getAttribute('data-cc-tier')));
}
function onChange(e) {
var s = e.target;
if (!s.matches('select[data-cc-unit]') || !state.data) return;
var units = unitsOf(state.data, state.cart);
units[Number(s.getAttribute('data-cc-unit'))] = Number(s.value);
applyUnits(state.data, units);
}
function formError(form, msg) {
var pf = form.closest('product-form');
var wrap = pf && pf.querySelector('.product-form__error-message-wrapper');
if (wrap) {
var m = wrap.querySelector('.product-form__error-message');
if (m) m.textContent = msg;
wrap.hidden = false;
} else {
console.warn('[ComboCart]', msg);
}
}
function addFromForm(form, submitter) {
var btn = submitter || form.querySelector('[type="submit"]');
if (btn) {
if (btn.getAttribute('aria-disabled') === 'true' || btn.disabled) return;
btn.setAttribute('aria-disabled', 'true');
btn.classList.add('loading');
var sp = btn.querySelector('.loading__spinner');
if (sp) sp.classList.remove('hidden');
}
var pf = form.closest('product-form');
var wrap = pf && pf.querySelector('.product-form__error-message-wrapper');
if (wrap) wrap.hidden = true;
api('cart/add.js', new FormData(form))
.then(function (res) {
var item = res.items ? res.items[0] : res;
state.focus = item.handle;
try { sessionStorage.setItem('cc-focus', item.handle); } catch (e) {}
var modal = form.closest('quick-add-modal');
if (modal && typeof modal.hide === 'function') modal.hide(true);
if (on('openOnAdd', true)) { open(); return refresh(); }
return updateBubble();
})
.catch(function (err) { formError(form, err.message); })
.then(function () {
if (!btn) return;
btn.removeAttribute('aria-disabled');
btn.classList.remove('loading');
var sp2 = btn.querySelector('.loading__spinner');
if (sp2) sp2.classList.add('hidden');
});
}
document.addEventListener('submit', function (e) {
var form = e.target;
if (!(form instanceof HTMLFormElement)) return;
var action = form.getAttribute('action') || '';
if (action.indexOf('/cart/add') === -1) return;
e.preventDefault();
e.stopImmediatePropagation();
addFromForm(form, e.submitter);
}, true);
document.addEventListener('click', function (e) {
var a = e.target.closest && e.target.closest('#cart-icon-bubble');
if (!a) return;
e.preventDefault();
e.stopImmediatePropagation();
open();
refresh();
}, true);
window.addEventListener('pageshow', function (e) { if (e.persisted) updateBubble(); });
function rebuild() {
var wasOpen = els.root && els.root.classList.contains('is-open');
if (els.root) els.root.parentNode.removeChild(els.root);
els = {};
document.documentElement.classList.remove('cc-lock');
if (wasOpen) { open(); render(); }
}
function isCC(e) { return e.target && e.target.querySelector && e.target.querySelector('script[data-cc-settings]'); }
document.addEventListener('shopify:section:load', function (e) { if (isCC(e)) { L.readSettings(e.target); rebuild(); } });
document.addEventListener('shopify:section:select', function (e) { if (isCC(e)) { open(); refresh(); } });
document.addEventListener('shopify:section:deselect', function (e) { if (isCC(e)) close(); });
window.ComboCart = { open: function () { open(); return refresh(); }, close: close, refresh: refresh };
})();